import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { MySignedCardsResponse } from "tng-address-collection-shared/types/apiTypes.ts";
import { queryKeys } from "./queryKeys.ts";

export const useDeleteCardFromMySignedCardsCache = () => {
  const queryClient = useQueryClient();

  return useCallback(
    (cardId: string) => {
      queryClient.setQueryData<MySignedCardsResponse>(
        queryKeys.mySignedCards(),
        (old) =>
          old && { cards: old.cards.filter((card) => card.id !== cardId) },
      );
    },
    [queryClient],
  );
};
